export function diferenciaEntreFechaHoras(horaInicio:Date, horaFin:Date)
{
    return Math.floor((horaFin.getTime() - horaInicio.getTime())/1000);
}